<template>
  <v-expand-transition>
    <v-row v-show="show" justify="center" align="center" class="dialpad pt-8 pl-4 pr-4" no-gutters>
      <v-col v-for="[ key, sub ] in dialpadData()" :key="key"
              cols="4" class="dialpad-btn">
        <v-btn large block text :disabled="isCalling"
          @click="$emit('dialpad-keypress', key)"
          :retain-focus-on-click="true"
          class="text-lowercase pl-8">
          <span class="font-weight-bold headline teal--text">
            <span :class="{'key-asterisk': key === '*'}">
              {{key}}
            </span>
          </span>&nbsp;
          <span class="caption">{{sub}}</span>
        </v-btn>
      </v-col>
    </v-row>
  </v-expand-transition>
</template>

<script>
export default {
  name: 'phone-app-dialpad',
  props: {
    show: {
      type: Boolean,
      required: true
    },
    isCalling: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    dialpadData: function () {
      return [
        ['1', ''],
        ['2', 'abc'],
        ['3', 'def'],
        ['4', 'ghi'],
        ['5', 'jkl'],
        ['6', 'mno'],
        ['7', 'pqrs'],
        ['8', 'tuv'],
        ['9', 'wxyz'],
        ['*', ''],
        ['0', '+'],
        ['#', '']
      ]
    }
  }
}
</script>

<style>
</style>
